/* eslint-disable no-console */
import React, { useEffect } from 'react'
import { Container } from 'react-bootstrap'
import { RootState, Dispatcher } from 'AppTypes'
import { connect } from 'react-redux'
import * as actions from './state_management/actions'
import TopPageBody from './partials/TopPageBody'
import TopFilter from './partials/TopFilter'
import TopMenu from './partials/TopMenu'
import './style.scss'

const mapStateToProps = (state: RootState) => ({
  foodCategoryGroups: state.topPage.foodCategoryGroups,
  defaultMarks: state.topPage.defaultMarks
})

const mapDispatchToProps = (dispatch: Dispatcher) => ({
  getFoodCategoryGroup: () => dispatch(actions.getFoodCategoryGroup()),
  getDefaultMark: () => dispatch(actions.getDefaultMark())
})

type Props = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>
const TopPage: React.FC<Props> = ({
  foodCategoryGroups,
  defaultMarks,
  getDefaultMark,
  getFoodCategoryGroup
}) => {
  useEffect(() => {
    getFoodCategoryGroup()
    getDefaultMark()
  }, [getDefaultMark, getFoodCategoryGroup])

  const onSelectCategory = (category: any) => {
    const element = document.getElementById(`category-${category.id}`)
    if (element) {
      const yOffset = -90
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset
      window.scrollTo({
        top: y,
        behavior: 'smooth'
      })
    }
  }

  return (
    <div className="top-page">
      <Container>
        <TopFilter defaultMarks={defaultMarks} />
        <TopMenu foodCategoryGroups={foodCategoryGroups} onSelectCategory={onSelectCategory} />
        <TopPageBody />
      </Container>
    </div>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TopPage)
